<div class="second-header"><ng-content></ng-content></div>
<div #actionButtons></div>
